import classnames from 'classnames';
import dayjs from 'dayjs';
import { Button } from 'components/common';
import { ProfileImage } from 'components/users';
import { useResponsiveWidth } from 'libs';

interface User {
  email: string;
  name: string;
  photo_url: string;
}

interface JoinRequest {
  id: number;
  user: User;
  created_at: string;
}
interface PendingJoinRequestsProps {
  isLoading: boolean;
  joinRequests: JoinRequest[];
  onAccept: (joinRequest: JoinRequest) => void;
  onDecline: (joinRequest: JoinRequest) => void;
}

const PendingJoinRequests = ({ isLoading, joinRequests = [], onAccept, onDecline }: PendingJoinRequestsProps) => {
  const { isMinMd } = useResponsiveWidth();

  return (
    <div className="card-body">
      <div className="d-flex flex-column w-100">
        {isMinMd && (
          <div className="align-items-center border-bottom d-flex flex-row fw-bold p-1">
            <div className="flex-basis-60px" />
            <div className="flex-basis-40">Email</div>
            <div className="flex-basis-40">Date requested</div>
            <div className="flex-basis-20" />
          </div>
        )}
        {joinRequests.map((joinRequest) => {
          const createdAt = dayjs(joinRequest.created_at);
          return (
            <div
              className={classnames('border-bottom d-flex p-2', {
                'align-items-center': isMinMd,
                'flex-column justify-content-center position-relative': !isMinMd,
              })}
              key={joinRequest.id}
            >
              <div className="flex-basis-60px">
                <ProfileImage photoUrl={joinRequest.user.photo_url} userName={joinRequest.user.name} />
              </div>
              <div className="flex-basis-40 truncate">
                {!isMinMd && <span className="fw-bold me-1">Email: </span>}
                {joinRequest.user.email}
              </div>
              <div className="flex-basis-40">
                {!isMinMd && <span className="fw-bold me-1">Date requested: </span>}
                {createdAt.format('MMM. DD, YYYY')}
              </div>
              <div className={classnames('flex-basis-20', { 'my-2': !isMinMd })}>
                <div className={classnames('d-flex gap-2', { 'justify-content-end': isMinMd })}>
                  <Button disabled={isLoading} onClick={() => onAccept(joinRequest)} text="bold" variant="primary-dark">
                    Accept
                  </Button>
                  <Button
                    disabled={isLoading}
                    onClick={() => onDecline(joinRequest)}
                    text="bold"
                    variant="border-danger"
                  >
                    Decline
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PendingJoinRequests;
